import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {first} from "rxjs/operators";
import {Page} from "../models/page";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DateRange} from "../models/dateRange";
import {MatDialog} from "@angular/material/dialog";
import {VoucherTemplateGroupService} from "../services/voucherTemplateGroup.service";
import {VoucherTemplateGroupList} from "../models/voucherTemplateGroupList";
import {VoucherTemplateGroup} from "../models/voucherTemplateGroup";
import {DeleteGroupDialogComponent} from "./dialog/deleteGroup.component";

@Component({
    templateUrl: './voucherTemplateGroup.component.html',
    styleUrls: ['./voucherTemplateGroup.component.scss']
})
export class VoucherTemplateGroupComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    dateRange: DateRange;
    deleteDialogRef: any;

    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private voucherTemplateGroupService: VoucherTemplateGroupService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        public _matDialog: MatDialog,
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 10;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Voucher template groups');
    }

    ngOnInit() {
        this.setPage({offset: 0});
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.rows = [];
        this.page.totalElements = 0;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.voucherTemplateGroupService.getAll(pageInfo.offset * pageInfo.limit, pageInfo.limit).pipe(first())
            .subscribe((res: VoucherTemplateGroupList) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    showConfirmDeletionDialog(group: VoucherTemplateGroup) {
        this.deleteDialogRef = this._matDialog.open(DeleteGroupDialogComponent, {
            panelClass: 'delete-group-dialog',
            data      : {
                action : 'show',
                group: group,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.voucherTemplateGroupService.delete(group.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
